import {ImageProps} from './image.props';

export function Image(props: ImageProps) {
  const {imgAlt, imgSrc, imgHeight} = props;
  return <img alt={imgAlt} src={imgSrc} style={{height: imgHeight}} />;
}
